export * from 'server/models/MarineTrafficServiceVessel';


// WEBPACK FOOTER //
// ./data/models/MarineTrafficServiceVessel.ts